import { render, staticRenderFns } from "./lifeIndex.vue?vue&type=template&id=0cb73eb1&scoped=true"
import script from "./lifeIndex.vue?vue&type=script&lang=js"
export * from "./lifeIndex.vue?vue&type=script&lang=js"
import style0 from "./lifeIndex.vue?vue&type=style&index=0&id=0cb73eb1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb73eb1",
  null
  
)

export default component.exports